import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, change, getFormValues } from 'redux-form';
import _trim from 'lodash/trim';

import { FormGroupField, FormGroupSelect } from 'components/Form';
import Toggler from 'components/Toggler';
import TrashTooltip from 'components/TrashTooltip';

import FORM_NAMES from 'constants/formNames';

import { entityType, entiyFeatureType, featureTypesType } from 'types';

import './style.scss';

export class Feature extends Component {
  static propTypes = {
    isPublic: PropTypes.bool,
    currentEntity: entityType,
    item: entiyFeatureType,
    feature_type: PropTypes.string,
    name: PropTypes.string,
    archived: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    types: PropTypes.arrayOf(featureTypesType),
    public: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onDelete: PropTypes.func.isRequired,
    // Means that newly created feature isn't created yet
    isNotSynchronized: PropTypes.bool.isRequired,
    change: PropTypes.func.isRequired,
  };

  handleRef = el => {
    this.tooltip = el;
  };

  shouldBeDisabled = () => {
    const { item, currentEntity } = this.props;
    return !!(
      item.xpack_resource ||
      item.name === 'value' ||
      item.archived ||
      currentEntity.xpack_resource ||
      currentEntity.archived
    );
  };

  handleDelete = () => {
    if (this.props.isNotSynchronized) {
      this.props.onDelete();
      return;
    }

    // If Feature already created and synchronized with the server
    // then archive it instead of deleting on client
    this.props.change(this.props.archived, true);
  };

  render() {
    const { item, types, isPublic } = this.props;

    if (!item) {
      return null;
    }

    const isDisabled = this.shouldBeDisabled();
    return (
      <div styleName="feature">
        <Field
          autoFocus={item.autoFocus}
          component={FormGroupField}
          data-test="feature-name"
          disabled={isDisabled}
          isArchived={item.archived}
          name={this.props.name}
          normalize={_trim}
          placeholder="Feature name"
          type="text"
        />

        <Field
          component={FormGroupSelect}
          data-test="feature-types"
          disabled={isDisabled}
          name={this.props.feature_type}
          options={types.map(({ name }) => ({
            label: name,
            value: name,
          }))}
          placeholder="Type"
        />

        <Field
          component={Toggler}
          isDisabled={isDisabled || !isPublic}
          label="Public"
          name={this.props.public}
          styleName="toggler"
        />

        {!isDisabled && (
          <TrashTooltip
            styleName="trash"
            text="Delete feature"
            onDelete={this.handleDelete}
          />
        )}
      </div>
    );
  }
}

export default connect(
  state => ({
    isPublic: getFormValues(FORM_NAMES.ENTITIES.INSPECT)(state).public,
  }),
  dispatch => ({
    change: (name, value) =>
      dispatch(change(FORM_NAMES.ENTITIES.INSPECT, name, value)),
  }),
)(Feature);
